import { ThemeOptions } from '@mui/material/styles/createTheme'
import CSS from 'csstype';

// Dimensions
export const DRAWER_WIDTH = 280
export const ASIDE_WIDTH = 80
export const HEADER_HEIGHT = 72

export const ELEMENT_RADIUS = '0.25rem'
export const ELEMENT_RADIUS_MID = '0.75rem'

// Colors
export const BG_DARK_GRAY = '#e1e1e2'
export const DISABLED_GRAY = 'rgba(0, 0, 0, 0.5)'

export const GREY_BORDER = 'rgba(224, 224, 224, 1)'

export const PURE_BLACK = '#000000'
export const PURE_WHITE = '#ffffff'

export const PRIMARY_YELLOW = '#ffd750'
export const PRIMARY_ORANGE = 'rgb(255, 73, 0)'
export const PRIMARY_PINK = 'rgb(253, 119, 174)' 
export const PRIMARY_BLUE = '#64b5f6' 
export const PRIMARY_GREEN = '#73d5a6' 
export const PRIMARY_RED = '#f7645f'
export const PRIMARY_GRASS_GREEN = 'rgb(99, 192, 72)' 

export const PRIMARY_MEDIUM_BLUE = '#bbdefb'

export const PRIMARY_LIGHT_YELLOW = '#fff9e3'
export const PRIMARY_LIGHT_PINK = '#f8e4f6' 
export const PRIMARY_LIGHT_BLUE = '#e3f2fd'
export const PRIMARY_LIGHT_GREEN = '#ebf3e0' 

export const PRIMARY_TRANSPARENT_YELLOW = '#FEFAE4'
export const PRIMARY_TRANSPARENT_ORANGE = '#faedbe'
export const PRIMARY_TRANSPARENT_PINK = '#F6EDF6' 
export const PRIMARY_TRANSPARENT_BLUE = '#D8F4F5'
export const PRIMARY_TRANSPARENT_GREEN = '#D9EEBF' 

export const BRIGHT_GREEN = 'rgb(99, 192, 72)' 


export const THEME_GRAY = '#9fa0a4'
export const THEME_NEUTRAL_GRAY = '#64748B'


export const themeConfigsLight: ThemeOptions = {
  palette: {
    primary: {
      main: PRIMARY_YELLOW,
      contrastText: PURE_BLACK,
    },
    secondary: {
      main: PRIMARY_PINK,
      contrastText: PURE_WHITE,
    },
    success: {
      main: PRIMARY_GREEN,
      contrastText: PURE_BLACK,
    },
    error: {
      main: PRIMARY_RED,
      contrastText: PURE_BLACK,
    },
    background: {
      default: PRIMARY_TRANSPARENT_YELLOW,
    },
    neutral: {
      main: THEME_NEUTRAL_GRAY,
      contrastText: PURE_WHITE,
    },
    white: {
      main: PURE_WHITE,
      contrastText: PURE_BLACK,
    },
    black: {
      main: PURE_BLACK,
      contrastText: PURE_WHITE,
    },
    blue: {
      main: PRIMARY_BLUE,
      contrastText: PURE_BLACK,
    },
    green: {
      main: PRIMARY_GREEN,
      contrastText: PURE_BLACK,
    },
    text: {
      disabled:DISABLED_GRAY,
    },
  },
  components: {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'inherit',
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          '& .MuiButtonGroup-grouped:not(:last-of-type)': {
            borderRight: '1px solid rgba(255,255,255, 0.2)',
          },
        },
      },
    },
  },
}

// General Configs
export const generalConfigs: ThemeOptions = {
  typography: {
    button: {
      textTransform: 'none',
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: PRIMARY_TRANSPARENT_YELLOW
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontSize: '1rem !important',
          borderRadius: `${ELEMENT_RADIUS_MID} !important`,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            // padding: '0.75rem 0.75rem 0.75rem 2.5rem',
          },
          '&.MuiAutocomplete-inputRoot': {
            // padding: '0.6rem 0.5rem 0.6rem 2.5rem !important',
          },
          '&.Mui-disabled': {
            background: 'rgba(224, 224, 224, 0.4)'
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiAutocomplete-tag': {
            maxWidth: '75%',
            margin: '0.2 0.5rem',
          },
        },
        option: {
          '&[aria-selected="true"]': {
            backgroundColor: PURE_WHITE,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#9fa0a4 !important',
          top: '-0.25rem !important',
          '&[data-shrink="true"]': {
            left: '2px !important',
          },
        },
        asterisk: { color: 'red' },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          position: 'absolute',
          bottom: '-1.25rem',
          color: 'red',
        },
      },
    },
  },
}

// Add new color
declare module '@mui/material/styles' {
  interface Palette {
    neutral: Palette['primary']
    white: Palette['primary']
    black: Palette['primary']
    blue: Palette['primary']
    green: Palette['primary']
  }
  interface PaletteOptions {
    neutral: PaletteOptions['primary']
    white: PaletteOptions['primary']
    black: PaletteOptions['primary']
    blue: PaletteOptions['primary']
    green: PaletteOptions['primary']
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true
    white: true
    black: true
    blue: true
    green: true
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    neutral: true
    white: true
    black: true
    blue: true
    green: true
  }
}
declare module '@mui/material/Fab' {
  interface FabPropsColorOverrides {
    neutral: true
    white: true
    black: true
    blue: true
    green: true
  }
}


//Action icons
export const actionIcon: any = {
  borderRadius: '50%',
  width: '1.5rem',
  height: '1.5rem',
  padding: '0',
  minWidth: 'auto',
  marginRight: '0.2rem',
  display: 'flex',
  alignItems: 'center',
  border: 'none',
}


export const filesIcon: any = {
  '&:hover': { background: PRIMARY_BLUE, '& svg': { color: '#000' } },
}

export const eyeIcon: any = {
  '&:hover': { background: PRIMARY_YELLOW, '& svg': { color: '#000' } },
}

export const pencilIcon: any = {
  '&:hover': {  background: PRIMARY_GREEN, '& svg': { color: '#000' } },
}

export const trashIcon: any = {
  '&:hover': {  background: PRIMARY_RED, '& svg': { color: '#000' } },
}

export const actionButton: any = {
  '&:hover': { background: PRIMARY_GREEN, opacity: '0.7', border: 'none', '& svg': { color: '#000' } },
  '& svg': { marginRight: '0.3rem', fontSize: '1.5rem' },
  '& > span': { fontSize: '1rem' },
  width: 'auto',
  height: '2.0rem',
  padding: '0px 20px',
  minWidth: 'auto',
  marginRight: '0.2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
}

export const STATUS_COLORS = {
  "gap": "red",
  "bridge": "#ffd853",
  "strength": "#73d5a6"
}
